export default "__VITE_ASSET__CR58swaL__"